export function getBrowserPath() {
  return window.location.pathname + window.location.search;
}
